import { render } from "./EconomyMunicipality.vue?vue&type=template&id=4ecf7045"
import script from "./EconomyMunicipality.vue?vue&type=script&lang=js"
export * from "./EconomyMunicipality.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__